import React from 'react'
import Hero from '../components/industries/Hero';
import FooterCTACard from "../components/FooterCTACard";
import CapitalBenefit from '../components/industries/CapitalBenefit';
import Footerhead from '../components/Footerhead';
import TrustedSection from '../components/home/TrustedSection';

const Industries = () => {
  return (
    <>
      <Hero />
      <TrustedSection />

      <CapitalBenefit />
      <FooterCTACard />
      <Footerhead />
    </>

  )
}

export default Industries;